export const LICENSEASSIGNSITE_GET_LICENSED_COUNT =
  'LICENSEASSIGNSITE_GET_LICENSED_COUNT';
export const LICENSEASSIGNSITE_GET_LICENSED_COUNT_ERROR =
  'LICENSEASSIGNSITE_GET_LICENSED_COUNT_ERROR';
export const LICENSEASSIGNSITE_UPDATE = 'LICENSEASSIGNSITE_UPDATE';
export const LICENSEASSIGNSITE_CLEAR_ERROR = 'LICENSEASSIGNSITE_CLEAR_ERROR';
export const LICENSEASSIGNSITE_ERROR = 'LICENSEASSIGNSITE_ERROR';
export const LICENSEASSIGNSITE_LOADING = 'LICENSEASSIGNSITE_LOADING';
export const LICENSEASSIGNSITE_GET = 'LICENSEASSIGNSITE_GET';
export const LICENSEASSIGNSITE_UPDATE_COLLECTION =
  'LICENSEASSIGNSITE_UPDATE_COLLECTION';



// WEBPACK FOOTER //
// ./src/pages/assignlicense/state/types.js